/*
 * This file provides additional checks that we are using to
 * hide certain parts of the page.
 *
 * Using useHasSelectedFilters() we can check if the user is
 * currently applying filters.
 */
import { useSelectedFilters } from 'components/shared/FilterContext';

export function useHasSelectedFilters() {
  const { hasSelected } = useSelectedFilters();
  return hasSelected;
}

export const HasSelectedFilters = ({ children }) => {
  const hasSelectedFilters = useHasSelectedFilters();
  if (typeof children === 'function') {
    return children({ hasSelectedFilters });
  }
  return hasSelectedFilters ? children : null;
};
